import AttachmentList, { AttachmentListProps } from "./AttachmentList";

export const ProjectAttachmentList: React.FC<AttachmentListProps> = (props) => <AttachmentList {...props} type="project" />;
